import { createRoute } from '@tanstack/react-router';
import { rootRoute } from './__root';
import { SubscriptionCheckout } from '@/features/payments';
import { AppRoutes } from '@/shared/lib/routes';

export const checkoutRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: AppRoutes.CHECKOUT,
  component: SubscriptionCheckout,
});
